export const OpsRoute = {
  OPS: 'ops'
};
